<template>
    <settings-page :title="title" :description="description">
        <div>
            <h2 class="text-setting__title">Global Header</h2>
            <textarea
                v-model="headerData"
                class="flex-form__textarea"
                @input="onInput"
            />
            <h2 class="text-setting__title">Global Footer</h2>
            <textarea
                v-model="footerData"
                class="flex-form__textarea"
                @input="onInput"
            />
        </div>
    </settings-page>
</template>

<script>
import { mapState } from 'vuex';

import SettingsPage from '@/components/settings/shared/settings-page';

export default {
    name: 'settings-flex',
    components: { SettingsPage },

    data() {
        return {
            title: 'Flex Data',
            description: 'This section controls global Flex data',
            headerData: '',
            footerData: '',
        };
    },

    computed: {
        ...mapState({
            settings: state => state.settings,
        }),
    },

    mounted() {
        this.headerData = this.settings.flex.header;
        this.footerData = this.settings.flex.footer;
    },

    methods: {
        onInput() {
            this.$emit('input', 'flex', {
                header: this.headerData,
                footer: this.footerData,
            });
        },
    },
};
</script>
